import * as React from 'react';
import { connect } from 'react-redux';
import { IProductInfo, IState, IUserInfo } from '../CustomTypes';
import { svgShoppingBasket } from '../icons';
import './ShoppingBasket.scss';

interface IShoppingBasketProps {
  productInfo: IProductInfo;
  userInfo: IUserInfo;
  pathname: string;
}

export class ShoppingBasket extends React.Component<IShoppingBasketProps, {}> {
  public render() {
    const { pathname } = this.props;
    if (
      pathname.indexOf('/receipt') !== -1 ||
      pathname.indexOf('/duplicate') !== -1
    ) {
      return null;
    }
    const { header, price } = this.props.productInfo;
    const { spidId, spidPrimaryEmail } = this.props.userInfo;
    return (
      <div className="shopping-basket">
        <span className="product">
          <span className="icon">{svgShoppingBasket(19)}</span>
          <span className="text">
            <span className="productname">{header}</span>
            <span className="price">kr {price},-</span>
          </span>
        </span>
        {spidId && (
          <span className="email">
            <span className="emailText">Du er registrert med: </span>
            {spidPrimaryEmail}
          </span>
        )}
      </div>
    );
  }
}

export default connect(
  (state: IState) =>
    ({
      pathname: state.router.location.pathname,
      productInfo: state.productInfo,
      userInfo: state.userInfo
    } as IShoppingBasketProps)
)(ShoppingBasket);



// WEBPACK FOOTER //
// ./src/layout-components/ShoppingBasket.tsx